// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__oYLbf","comment":"styles_comment__1J1FG"};